module.exports = __webpack_public_path__ + "media/Instruction_A13.2720f892.mp3";